import { $window } from '@umu/umu-dom';
import { getData } from '@umu/umu-util';
import { IDepartmentList } from './type';
import { confirmUserRole } from '../../@utils/userRole';

export function formatDepartmentName(
    eName: string,
    departmentName: string,
    id: string,
    parentDepartment: IDepartmentList[] = [],
): string {
    const names: string[] = [eName, ...parentDepartment.map((item) => item.department_name)];

    if (departmentName && String(id) !== '0') {
        names.push(departmentName);
    }

    return names.join('/');
}

export const onAllowPermissionSwitch = (oriData: any) => {
    const allowPermissionRoleList = [3, 4];
    const isAllow = oriData && oriData.hasOwnProperty('manage_permission') && !oriData.manage_permission;
    const enterpriseInfo: any = getData(($window.pageData as any).data, 'teacher_info', 'enterpriseInfo') || {};
    const roleType = enterpriseInfo.role_type || '0';
    return isAllow && allowPermissionRoleList.indexOf(Number(roleType)) === -1;
};

const onGetRole = () => {
    return confirmUserRole();
};

export const role = onGetRole();
